import type { TButtonColor } from "@atoms/Button/types";
import type { TPlanCardVariants } from "../types";

type TPlanCardVariantProps = {
  wrapperClass: string;
  titleClass: string;
  descriptionClass: string;
  moneyElement: {
    primaryClass: string;
    secondaryClass: string;
  };
  creditElement: {
    wrapperClass: string;
    image: {
      src: string;
      alt: string;
    };
    creditClass: string;
    cardClass: string;
    enterpriseClass: string;
  };
  buttonColor: TButtonColor;
  benefitsProps: {
    initialTextClass: string;
    sumImage: {
      src: string;
      alt: string;
    };
    verifiedImage: {
      src: string;
      alt: string;
    };
    verifiedTextClass: string;
  };
  dotsClass: string;
};

type TPlanCardAllVariants = {
  [key in TPlanCardVariants]: TPlanCardVariantProps;
};

const defaultCard: Omit<TPlanCardVariantProps, "buttonColor"> = {
  wrapperClass: "bg-white",
  titleClass: "text-blue-800",
  descriptionClass: "text-brown-200",
  moneyElement: {
    primaryClass: "text-blue-500",
    secondaryClass: "text-gray-600",
  },
  creditElement: {
    wrapperClass: "border-gray-100",
    image: {
      src: "/static/logos/data-stone-blue-icon.svg",
      alt: "icon",
    },
    creditClass: "text-blue-500",
    cardClass: "border-gray-190 bg-white",
    enterpriseClass: "text-gray-800",
  },
  benefitsProps: {
    initialTextClass: "text-gray-450",
    sumImage: {
      src: "/static/icons/blue-sum.svg",
      alt: "icon",
    },
    verifiedImage: {
      src: "/static/icons/blue-verified.svg",
      alt: "icon",
    },
    verifiedTextClass: "text-gray-800",
  },
  dotsClass: "bg-gray-150",
};

export const planCardVariant: TPlanCardAllVariants = {
  lightBlueButton: {
    ...defaultCard,
    buttonColor: "lightBlue",
  },
  darkBlueButton: {
    ...defaultCard,
    buttonColor: "darkBlue",
  },
  whiteButton: {
    wrapperClass: "bg-blue-500",
    titleClass: "text-white",
    descriptionClass: "text-white/75",
    moneyElement: {
      primaryClass: "text-white",
      secondaryClass: "text-white/75",
    },
    creditElement: {
      wrapperClass: "border-white/75",
      image: {
        src: "/static/logos/data-stone-white-icon.svg",
        alt: "icon",
      },
      creditClass: "text-white",
      cardClass: "border-white/75 bg-blue-450",
      enterpriseClass: "text-white",
    },
    buttonColor: "white",
    benefitsProps: {
      initialTextClass: "text-white",
      sumImage: {
        src: "/static/icons/white-sum.svg",
        alt: "icon",
      },
      verifiedImage: {
        src: "/static/icons/white-verified.svg",
        alt: "icon",
      },
      verifiedTextClass: "text-white",
    },
    dotsClass: "bg-white/20",
  },
};
